
import React from 'react';
import { BluetoothSearching, BluetoothOff } from 'lucide-react';

interface BluetoothNoDevicesProps {
  isScanning: boolean;
}

const BluetoothNoDevices: React.FC<BluetoothNoDevicesProps> = ({ isScanning }) => (
  <div className="flex flex-col items-center justify-center p-8 bg-gray-50 rounded-xl">
    {isScanning ? (
      <div className="flex flex-col items-center space-y-4">
        <div className="relative">
          <BluetoothSearching size={40} className="text-blue-500 animate-spin" />
        </div>
        <p className="text-gray-600">Searching for transfer-enabled devices...</p>
      </div>
    ) : (
      <div className="flex flex-col items-center space-y-4">
        <BluetoothOff size={40} className="text-gray-400" />
        <p className="text-gray-600">No transfer-enabled devices found. Try scanning again.</p>
      </div>
    )}
  </div>
);

export default BluetoothNoDevices;
